import { $ } from "@/common/Axios";

export default {
  /**
   * 校企
   */
  enterpriseCompany_transferCreate: {
    /*
     * 移交创建人
     * createId 原创建人 (integer query required)
     * newCreateId 新创建人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/enterprise/enterpriseCompany/transferCreate", p, c),
  },
  enterpriseCompany_changeCreate: {
    /*
     * 更换创建人
     * id id (integer query required)
     * createId 创建人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/enterprise/enterpriseCompany/changeCreate", p, c),
  },
  enterpriseCompany: {
    /*
     * 添加
     * enterpriseCompany  ( query required)
     */
    post: (p, c) => $.post("/api/ums/enterprise/enterpriseCompany", p, c),
  },
  enterpriseCompany_createQrCode: {
    /*
     * 生成企业优惠二维码
     * enterpriseId 企业ID (integer query required)
     * extraInfos 自定义Json值 (string query required)
     * batch 批次 (string query required)
     * showTeacher 是否显示招生老师姓名:是、否 (string query required)
     * days 有效期（天） (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompany/createQrCode", p, c),
  },
  enterpriseCompany_list: {
    /*
     * 企业列表
     */
    get: (p, c) => $.get("/api/ums/enterprise/enterpriseCompany/list", p, c),
  },
  enterpriseCompany_listSimple: {
    /*
     * 简易企业列表
     * hasStudent 只选取有学生的企业, 1是 (integer query )
     * selfFlag 是否只看自己创建的企业, 1是 (integer query )
     * discountFlag 是否有已申请优惠的企业, 1是 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompany/listSimple", p, c),
  },
  enterpriseCompany_getQrCodeValue: {
    /*
     * 根据企业优惠二维码查询value
     * key key (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompany/getQrCodeValue", p, c),
  },
  enterpriseCompany_remove: {
    /*
     * 删除
     * id 企业ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ums/enterprise/enterpriseCompany/remove", p, c),
  },

  /**
   * 校企优惠
   */
  enterpriseCompanyDiscount_sync: {
    /*
     * 同步
     * instanceId 审批实例ID (string query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompanyDiscount/sync", p, c),
  },
  enterpriseCompanyDiscount_apply: {
    /*
     * 申请优惠
     * enterpriseId 企业ID (integer query required)
     * dingDepartmentId 钉钉部门ID (integer query )
     * discountAmount 优惠金额 (number query required)
     * firstDiscountAmount 首次优惠金额 (number query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompanyDiscount/apply", p, c),
  },
  enterpriseCompanyDiscount_list: {
    /*
     * 根据企业ID查询优惠金额记录
     * enterpriseId 企业ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompanyDiscount/list", p, c),
  },

  /**
   * 校企学生
   */
  employee: {
    /*
     * 添加
     * employee  ( query required)
     */
    post: (p, c) => $.post("/api/ums/enterprise/employee", p, c),
  },
  employee_updateEmployeeEnterprise: {
    /*
     * 批量更换企业-选择校企学生
     * ids 校企学生列表IDS (array query required)
     * enterpriseId 新企业ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/employee/updateEmployeeEnterprise", p, c),
  },
  employee_changeEnterprise: {
    /*
     * 批量移交学生
     * originEnterpriseId 原企业ID (integer query required)
     * newEnterpriseId 新企业ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/employee/changeEnterprise", p, c),
  },
  employee_list: {
    /*
     * 校企学生列表
     */
    get: (p, c) => $.get("/api/ums/enterprise/employee/list", p, c),
  },
  employee_getBySchoolRollId: {
    /*
     * 根据合同编号获取校企学生信息
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/employee/getBySchoolRollId", p, c),
  },
};
